<div [ngStyle]="{background: wrongCode ? '#D243441A' : '#F9FDFD'}" class="mpocode">
  <p *ngIf="!wrongCode" class="fw-bold small">Enter Code</p>
  <p *ngIf="wrongCode" class="fw-bold small text-danger">Wrong Code</p>
  <div class="code">
    <input pInputText #digits type="text" *ngFor="let e of [].constructor(length); let i = index" [(ngModel)]="data[i]"
      (keydown)="onKeyDown($event, i)" (click)="setFocus(i)" (change)="onInputChange()" (paste)="onPaste($event)"
      [ngClass]="wrongCode ? 'shake' : ''" autofocus/>
  </div>
</div>